export const deserializeDate = (dateString: string): Date => new Date(dateString);
